import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, BadgeIcon } from 'lucide-react';
const ProfileScreen: React.FC = () => {
  return <div className="px-4 py-6" data-id="element-196">
      <div className="mb-6" data-id="element-197">
        <h1 className="text-xl font-bold text-gray-900" data-id="element-198">My Profile</h1>
        <p className="text-gray-600 text-sm" data-id="element-199">Your personal information</p>
      </div>
      {/* Profile Card */}
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-200">
        <div className="flex flex-col items-center mb-4" data-id="element-201">
          <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-3" data-id="element-202">
            <span className="text-blue-700 text-2xl font-bold" data-id="element-203">AH</span>
          </div>
          <h2 className="text-xl font-bold text-gray-900" data-id="element-204">Ahmed Hussein</h2>
          <div className="mt-1 flex items-center" data-id="element-205">
            <BadgeIcon className="w-4 h-4 text-blue-600 mr-1" data-id="element-206" />
            <span className="text-gray-700 text-sm" data-id="element-207">ITS: 12345678</span>
          </div>
          <div className="mt-1 px-3 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-208">
            Active Member
          </div>
        </div>
        <div className="border-t border-gray-200 pt-4" data-id="element-209">
          <div className="grid gap-4" data-id="element-210">
            <div className="flex items-start" data-id="element-211">
              <div className="w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center mr-3" data-id="element-212">
                <BadgeIcon className="w-4 h-4 text-blue-600" data-id="element-213" />
              </div>
              <div data-id="element-214">
                <p className="text-xs text-gray-500" data-id="element-215">Rank</p>
                <p className="text-gray-900" data-id="element-216">Guard - Level 2</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-217">
              <div className="w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center mr-3" data-id="element-218">
                <PhoneIcon className="w-4 h-4 text-blue-600" data-id="element-219" />
              </div>
              <div data-id="element-220">
                <p className="text-xs text-gray-500" data-id="element-221">WhatsApp Number</p>
                <p className="text-gray-900" data-id="element-222">+91 98765 43210</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-223">
              <div className="w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center mr-3" data-id="element-224">
                <MailIcon className="w-4 h-4 text-blue-600" data-id="element-225" />
              </div>
              <div data-id="element-226">
                <p className="text-xs text-gray-500" data-id="element-227">Email Address</p>
                <p className="text-gray-900" data-id="element-228">ahmed.hussein@example.com</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-229">
              <div className="w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center mr-3" data-id="element-230">
                <MapPinIcon className="w-4 h-4 text-blue-600" data-id="element-231" />
              </div>
              <div data-id="element-232">
                <p className="text-xs text-gray-500" data-id="element-233">Address</p>
                <p className="text-gray-900" data-id="element-234">123 Main Street, Dahod, Gujarat</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Additional Information */}
      <div className="bg-white rounded-lg shadow-sm p-4 mb-6" data-id="element-235">
        <h3 className="text-md font-semibold text-gray-900 mb-3" data-id="element-236">
          Emergency Contact
        </h3>
        <div className="flex items-start" data-id="element-237">
          <div className="mr-3" data-id="element-238">
            <p className="text-xs text-gray-500" data-id="element-239">Name</p>
            <p className="text-gray-900" data-id="element-240">Fatima Hussein</p>
          </div>
          <div className="ml-auto" data-id="element-241">
            <p className="text-xs text-gray-500" data-id="element-242">Phone</p>
            <p className="text-gray-900" data-id="element-243">+91 98765 12345</p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-244">
        <h3 className="text-md font-semibold text-gray-900 mb-3" data-id="element-245">
          Skills & Training
        </h3>
        <div className="flex flex-wrap gap-2" data-id="element-246">
          <span className="px-3 py-1 bg-blue-50 text-blue-700 text-xs rounded-full" data-id="element-247">
            First Aid
          </span>
          <span className="px-3 py-1 bg-blue-50 text-blue-700 text-xs rounded-full" data-id="element-248">
            Security Protocol
          </span>
          <span className="px-3 py-1 bg-blue-50 text-blue-700 text-xs rounded-full" data-id="element-249">
            Crowd Management
          </span>
          <span className="px-3 py-1 bg-blue-50 text-blue-700 text-xs rounded-full" data-id="element-250">
            Emergency Response
          </span>
        </div>
      </div>
    </div>;
};
export default ProfileScreen;